import { formatSwissTel } from "../formatting/contactFormatters";

export function initAntiSpam () {

    // - By default try to decode links
    document.querySelectorAll("a").forEach(link => {

        decodeAntiSpamContent(link);

    });

}

// - Callable self (api)
export const decodeAntiSpamContent = element => {
    
    if (!element || element.dataset.antispamDecoded === "1") return;

    // - Visible text — decode all label spans (link component renders two for hover effect)
    const labelSpans = element.querySelectorAll("span.--label");
    if (labelSpans.length) {
        labelSpans.forEach(span => {
            span.textContent = decodeIfBase64(span.textContent, span);
        });
    } else {
        const span = element.querySelector("span");
        if (span) {
            span.textContent = decodeIfBase64(span.textContent, span);
        } else if (element.childNodes.length === 1 && element.textContent) {
            element.textContent = decodeIfBase64(element.textContent, element);
        }
    }

    // - Tel and mailto
    const href = element.getAttribute("href");
    if (!href) {

        element.dataset.antispamDecoded = "1";
        return;

    }

    const idx = href.indexOf(":");
    if (idx === -1) {

        element.dataset.antispamDecoded = "1";
        return;

    }
    const protocol = href.slice(0, idx);
    const rest = href.slice(idx + 1);

    if (!["tel", "mailto"].includes(protocol)) {
        element.dataset.antispamDecoded = "1";
        return;
    }

    element.dataset.antispamDecoded = "1";

    // accepte "b64:XXXX" ou "XXXX"
    switch (protocol) {

        case 'mailto': {

            const qIdx = rest.indexOf("?");
            const addrPart = qIdx === -1 ? rest : rest.slice(0, qIdx);
            const qs = qIdx === -1 ? "" : rest.slice(qIdx); // garde "?subject=..."

            // accepte "b64:XXXX" ou "XXXX"
            const addrEncoded = addrPart.startsWith("b64:") ? addrPart.slice(4) : addrPart;

            if (isBase64(addrEncoded)) {
                const decodedAddr = atob(addrEncoded);
                element.setAttribute("href", `mailto:${decodedAddr}${qs}`);
            }

            return;
        }

        case 'tel': {

            const telEncoded = rest.startsWith("b64:") ? rest.slice(4) : rest;

            if (isBase64(telEncoded)) {
                let decoded = atob(telEncoded).replace(/\s+/g, "").replace('+', '00');


                element.setAttribute("href", `tel:${decoded}`);
            } else {

                console.warn('not decoded tel');

            }

            return;

        }

        default:

            return;

    }

};

function isBase64(str) {

    if (!str || typeof str !== "string") return false;

    const s = str.trim();
    const base64Regex = /^(?:[A-Za-z0-9+/]{4})*(?:[A-Za-z0-9+/]{2}==|[A-Za-z0-9+/]{3}=)?$/;

    if (!base64Regex.test(s)) return false;

    try {

        atob(s);
        return true;

    } catch {

        return false;

    }

}

function decodeIfBase64(str, element) {

    if (typeof str !== "string") return str;
    const s = str.trim();
    if (!s.startsWith("b64:")) return str;

    const decoded = atob(s.slice(4));

    if (element.dataset.format) {

        switch (element.dataset.format) {

            case 'swiss-tel':
                return formatSwissTel(decoded);

            default:
                return decoded;

        }

    }

    return decoded;

}